// extracted by mini-css-extract-plugin
export var active = "_4q-7";
export var container = "_4q-0";
export var evenWidth = "_4q-4";
export var large = "_4q-5";
export var outlet = "_4q-8";
export var slide = "_4q-2";
export var small = "_4q-6";
export var tab = "_4q-3";
export var tabs = "_4q-1";